import { useQuery } from '@tanstack/react-query';
import { ACTIVE_AGREEMENTS_KEY } from '../../utils/constants/queryKeys';
import { getAllActiveAgreements } from '../services/fn-api/Agreements';

export const useGetActiveAgreements = () => {
  return useQuery({
    queryKey: [ACTIVE_AGREEMENTS_KEY],
    queryFn: () => getAllActiveAgreements(),
    retry: false,
  });
};
